import { attributeToggle } from './node';

export default class Dropdown {
  private element: HTMLElement;

  private trigger: HTMLElement;

  private dropdown: HTMLElement;

  constructor(element: HTMLElement) {
    this.element = element;

    this.trigger = this.element.querySelector('[data-trigger]');
    this.dropdown = this.element.querySelector('[data-dropdown]');

    this.trigger.addEventListener('click', () => {
      if (this.dropdown.classList.contains('hidden')) this.open();
      else this.close();
    });

    document.addEventListener('click', (e) => {
      if (!this.dropdown.contains(e.target as HTMLElement)
        && !this.trigger.contains(e.target as HTMLElement)
      ) {
        this.close();
      }
    });

    this.dropdown.addEventListener('change', (e) => {
      const target = e.target as HTMLInputElement;
      this.trigger.textContent = target.value;
    });
  }

  open() {
    this.dropdown.classList.remove('hidden');
    attributeToggle(this.dropdown);
  }

  close() {
    this.dropdown.classList.add('hidden');
    attributeToggle(this.dropdown);
  }
}
